'use strict';

const DEFAULT_PARSER = {
    parse: value => null
};
const BIT_PARSER = {
    parse: reader => reader.readBit(8, 'data.params')
};
const UINT8_PARSER = {
    parse: reader => reader.readUInt8('data.params')
};
const BOOL_PARSER = {
    parse: reader => reader.readUInt8('data.params', value => value === 1)
};
const UINT16_LE_PARSER = {
    parse: reader => reader.readUInt16LE('data.params')
};
const UINT32_LE_PARSER = {
    parse: reader => reader.readUInt32LE('data.params')
};
const FLOAT_LE_PARSER = {
    parse: reader => reader.readFloatLE('data.params')
};
const STRING_PARSER = {
    parse: reader => reader.readString(reader.getLength() - 6, 'data.params')
};
const UNKNOWN = 'unknown';

let pair = require('../../../../../utils/pair')('name', 'parser');

const Factory = {
    0x00: pair(UNKNOWN, undefined),
    0x01: pair('UC_ID', STRING_PARSER),
    0x02: pair('DEBUG_LEVEL', UINT8_PARSER),
    0x03: pair('UART_MODE', require('./rule/uart-mode-parser')),
    0x04: pair('PACKAGE_SEPARATOR', UINT8_PARSER),
    0x05: pair('USER_WORK', require('./rule/user-work-parser')),
    0x06: pair('USER_GLOBAL', undefined),
    0x07: pair('DIGIT_CONDITION', require('./rule/digit-condition-parser')),
    0x08: pair('DIGIT_ACTION', require('./rule/digit-action-parser')),
    0x09: pair('MSG_CONDITION', require('./rule/message-condition-parser')),
    0x0a: pair('MSG_ACTION', require('./rule/message-action-parser')),
    0x0b: pair('TIME_SETTING', require('./rule/time-setting-parser')),
    0x0c: pair('ALARM_CONDITION', require('./rule/alarm-condition-parser')),
    0x0d: pair('MOBILE_STATUS', require('./rule/mobile-status-parser')),
    0x0e: pair('MOBILE_SIGNAL', UINT8_PARSER),
    0x0f: pair('INPUT_STATUS', require("./rule/input-status-parser")),
    0x10: pair('OUTPUT_STATUS', require("./rule/output-status-parser")),
    0x11: pair('PASSWORD_SETTING', require('./rule/password-setting-parser')),
    0x12: pair('MOBILE_NET', require('./rule/mobile-network-parser')),
    0x13: pair('MOBILE_NUM', STRING_PARSER),
    0x14: pair('MOBILE_PIN', STRING_PARSER),
    0x15: pair('APP_MODE', require('./rule/app-mode-parser')),
    0x16: pair('USSD_PREFIX', STRING_PARSER),
    0x17: pair('REPORT_INTERVAL', UINT32_LE_PARSER),
    0x18: pair('COMMAND_SUCCESS', UINT8_PARSER),
    0x19: pair('COMMAND_FAIL', UINT8_PARSER),
    0x1a: pair('STATUS_CHANGE', UINT8_PARSER),
    0x1b: pair('MESSAGE_ENCODING', require('./rule/message-encoding-parser')),
    0x1c: pair('MESSAGE_REPORT', UINT8_PARSER),
    0x1d: pair('MESSAGE_CONTROL', UINT8_PARSER),
    0x1e: pair("SMS/USSD_FORMAT", UINT8_PARSER),
    0x1f: pair('REPORT_NUMBER', STRING_PARSER),
    0x20: pair('CONTROL_NUMBER', STRING_PARSER),
    0x21: pair('DEVICE_STATUS', require('./rule/device-status-parser')),
    0x22: pair('MOBILE_PLMN', undefined),
    0x23: pair('AWS_REGION', STRING_PARSER),
    0x24: pair('AWS_DOMAIN', STRING_PARSER),
    0x25: pair('ROOT_CERT', STRING_PARSER),
    0x26: pair('DEVICE_CERT', STRING_PARSER),
    0x27: pair('PRIVATE_KEY', STRING_PARSER),
    0x28: pair('MOBILE_PERIODIC', UINT32_LE_PARSER),
    0x29: pair('COLLECT_INTERVAL', UINT32_LE_PARSER),
    0x2a: pair('AI_OSH', require('./rule/ai-osh-parser')),
    0x2b: pair('AI_OSL', require('./rule/ai-osl-parser')),
    0x2c: pair('ANALOG_CONDITION', require('./rule/ai-condition-parser')),
    0x2d: pair("AI_VALUE", require('./rule/ai-value-parser')),
    0x2e: pair('MQTT_KEEPALIVE', undefined),
    0x2f: pair('UART_CHANNEL', require('./rule/uart-channel-parser')),
    0x30: pair('UART_CHANNEL_COLLECT', require('./rule/uart-channel-collect-parser')),
    0x31: pair('UART_CHANNEL_CONDITION', require('./rule/uart-channel-condition')),
    0x32: pair("NONCE_CONFIG", STRING_PARSER),
    0x33: pair("APN_CONFIG", STRING_PARSER),
    0x34: pair("USSD_ENABLED", BOOL_PARSER),
    0x35: pair("MQTT_CONFIG", require('./rule/mqtt-config-parser')),
    0x36: pair("DEVICE_DESCRIPTION", STRING_PARSER),
    0x37: pair("TCP/UDP_CONFIG", require('./rule/tcp-udp-config-parser')),
    0x38: pair("TCP/UDP_STATUS", BIT_PARSER),
    0x39: pair("TIMESTAMP_CONFIG", UINT32_LE_PARSER),
    0x50: pair("LORAWAN_CONFIG", require('./rule/lorawan-config-parser')),
    0x70: pair('PROTOCOL_VERSION', UINT8_PARSER),
    0x71: pair('UC_TYPE', STRING_PARSER),
    0x72: pair('UC_SN', STRING_PARSER),
    0x73: pair('HARDWARE_VERSION', STRING_PARSER),
    0x74: pair('SOFTWARE_VERSION', STRING_PARSER),
};


function parse(reader) {
    let type = reader.readUInt8("data.param_type", value => Factory[value].name);
    let parser = Factory[type].parser;
    if (parser) {
        parser.parse(reader);
    } else {
        throw new Error("no handler for such param type");
    }
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule-parser-factory.js